export default __webpack_public_path__ + "static/media/La pagode.18cfd5fc.jpg";